"use client";

import Link from "next/link";
import { useState } from "react";
import { useAdminStores } from "@/lib/queries/use-admin";

export default function AdminStores() {
  const [q, setQ] = useState("");
  const { data, isLoading, isError } = useAdminStores({ q: q || undefined, sort: "created_desc" });
  const stores = data?.data ?? [];
  const meta = data?.meta;

  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-900">Stores</h1>
      <p className="mt-1 text-sm text-slate-500">All marketplace stores and their status.</p>

      <div className="mt-4">
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name…"
          className="w-72 rounded-md border border-slate-300 px-3 py-1.5 text-sm"
        />
      </div>

      {isError && (
        <p className="mt-4 rounded bg-red-50 p-3 text-sm text-red-700">
          Couldn&apos;t load stores. You may need admin access.
        </p>
      )}

      <div className="mt-4 bg-white rounded border border-slate-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200">
              <th className="text-left px-4 py-3 font-medium text-slate-500">Store</th>
              <th className="text-left px-4 py-3 font-medium text-slate-500">Location</th>
              <th className="text-left px-4 py-3 font-medium text-slate-500">Items</th>
              <th className="text-left px-4 py-3 font-medium text-slate-500">Status</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={4} className="px-4 py-6 text-center text-sm text-slate-400">
                  Loading…
                </td>
              </tr>
            )}
            {!isLoading && stores.length === 0 && (
              <tr>
                <td colSpan={4} className="px-4 py-6 text-center text-sm text-slate-400">
                  No stores match.
                </td>
              </tr>
            )}
            {stores.map((store) => {
              const location = [store.city, store.state].filter(Boolean).join(", ") || "—";
              return (
                <tr key={store.id} className="border-b border-slate-100 last:border-0">
                  <td className="px-4 py-3 font-medium text-slate-900">
                    <Link href={`/admin/stores/${store.id}`} className="hover:text-forest-700 hover:underline">
                      {store.name}
                    </Link>
                  </td>
                  <td className="px-4 py-3 text-slate-500">{location}</td>
                  <td className="px-4 py-3 text-slate-500">{store.item_count}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`inline-block text-xs font-medium px-2 py-0.5 rounded ${
                        store.is_verified ? "bg-forest-100 text-forest-800" : "bg-amber-100 text-amber-800"
                      }`}
                    >
                      {store.is_verified ? "Verified" : "Pending"}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {meta && (
        <p className="mt-3 text-xs text-slate-400">
          {meta.total} {meta.total === 1 ? "store" : "stores"}
        </p>
      )}
    </div>
  );
}
